module.exports = __webpack_public_path__ + "static/img/component.39f9ace6.svg";